const HERO_IMG = "/reimagined-hero.jpg";
const BOX_IMG = "/attoh-quarshie-boxer.jpg";
const FOOT_IMG = "/black-queens.jpg";
const RUN_IMG  = "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1400&q=80";

export default function Reimagined() {
  return (
    <div data-testid="reimagined-page" className="bg-white">
      <section className="relative isolate overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <img src={HERO_IMG} alt="Ghana Black Queens celebrating a goal" className="w-full h-full object-cover object-center" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/10" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-48 text-white">
          <p className="text-xs uppercase tracking-widest text-faytex-orange">Legacy Reimagined</p>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-7xl mt-4 tracking-tighter max-w-4xl">
            If she can wear it during a game, <span className="text-faytex-orange">you can wear it anywhere.</span>
          </h1>
          <p className="mt-8 max-w-3xl text-white/90 text-xl md:text-2xl font-heading leading-snug">
            Confidence doesn&rsquo;t stop when life gets active.
          </p>
          <p className="mt-5 max-w-3xl text-white/85 text-lg leading-relaxed">
            Whether she&rsquo;s training in the boxing ring, competing on the football field, running
            a business or navigating a busy day, Faytex is designed to move with her.
          </p>
          <p className="mt-4 max-w-3xl text-white/80 text-lg leading-relaxed">
            Our previous partnerships with organisations such as Ghana&rsquo;s Black Queens and Bukom
            Boxing Arena celebrate women whose determination, resilience and confidence inspire
            others every day.
          </p>
        </div>
      </section>

      {/* Two card grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 grid md:grid-cols-2 gap-8">
        <article data-testid="reimagined-boxing" className="rounded-3xl overflow-hidden border border-gray-100 shadow-soft hover:shadow-hover transition-shadow">
          <div className="relative h-72">
            <img src={BOX_IMG} alt="Bukom Boxing Arena" className="w-full h-full object-cover" />
            <span className="absolute top-4 left-4 text-[10px] uppercase tracking-widest bg-faytex-orange text-white px-3 py-1 rounded-full">Boxing</span>
          </div>
          <div className="p-8">
            <h3 className="font-heading text-3xl">Bukom Boxing Arena</h3>
            <p className="text-faytex-muted mt-4 leading-relaxed">
              Faytex previously partnered with Bukom Boxing Arena in support of female athletes
              pursuing excellence in boxing.
            </p>
            <p className="text-faytex-muted mt-3 leading-relaxed">
              The partnership reflected our belief that confidence is built through courage,
              discipline and determination — values shared by every woman who chooses Faytex.
            </p>
          </div>
        </article>

        <article data-testid="reimagined-football" className="rounded-3xl overflow-hidden border border-gray-100 shadow-soft hover:shadow-hover transition-shadow">
          <div className="relative h-72">
            <img src={FOOT_IMG} alt="Ghana Black Queens" className="w-full h-full object-cover" />
            <span className="absolute top-4 left-4 text-[10px] uppercase tracking-widest bg-faytex-pink text-white px-3 py-1 rounded-full">Football</span>
          </div>
          <div className="p-8">
            <h3 className="font-heading text-3xl">Ghana Black Queens</h3>
            <p className="text-faytex-muted mt-4 leading-relaxed">
              As part of Faytex&rsquo;s support for women&rsquo;s sport, the company previously
              partnered with Ghana&rsquo;s national women&rsquo;s football team, The Black Queens —
              celebrating confidence, resilience and excellence on and off the pitch.
            </p>
            <p className="text-faytex-muted mt-3 leading-relaxed">
              The partnership reflected our commitment to championing women who inspire the next
              generation through leadership, performance and perseverance.
            </p>
          </div>
        </article>
      </section>

      {/* Quote band */}
      <section className="bg-faytex-pinkLight">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-32 text-center">
          <p className="text-xs uppercase tracking-widest text-faytex-pink font-semibold">The Message</p>
          <blockquote className="font-heading text-4xl md:text-6xl mt-6 tracking-tighter leading-[1.05]">
            &ldquo;If she can wear it during a game, you can wear it anywhere.&rdquo;
          </blockquote>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 grid md:grid-cols-3 gap-6">
        {[RUN_IMG, BOX_IMG, FOOT_IMG].map((src, i) => (
          <div key={i} className="aspect-square rounded-3xl overflow-hidden">
            <img src={src} alt="" className="w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
          </div>
        ))}
      </section>
    </div>
  );
}
